import type { Preset, Level } from '../types/index.js';
import type { PresetConfig } from './node-api.js';

export const nextjsAppPreset: PresetConfig = {
  name: 'nextjs-app',
  description: 'Next.js full-stack application',
  rules: {
    basic: [
      'secrets.no-plaintext',
      'secrets.no-env-commit',
      'secrets.gitignore-required',
      'deps.lockfile.required',
      'deps.no-vulnerable',
      'deps.no-typosquatting',
      'security.cors.safe-default',
      'security.no-eval',
      'security.no-prototype-pollution',
      'auth.no-weak-jwt',
      'auth.no-hardcoded-credentials',
      'api.no-sensitive-logging',
      'sql.no-string-concat',
      'tests.no-skipped',
      'code.no-unused-vars',
    ],
    standard: [
      'secrets.no-plaintext',
      'secrets.no-env-commit',
      'secrets.gitignore-required',
      'deps.lockfile.required',
      'deps.no-unpinned',
      'deps.no-git-deps',
      'deps.no-vulnerable',
      'deps.no-typosquatting',
      'security.headers.required',
      'security.cors.safe-default',
      'security.no-eval',
      'security.no-unsafe-regex',
      'security.no-prototype-pollution',
      'auth.no-weak-jwt',
      'auth.no-hardcoded-credentials',
      'auth.session-secure',
      'api.validation.required',
      'api.no-sensitive-logging',
      'sql.no-string-concat',
      'tests.unit.required',
      'tests.coverage.min-50',
      'tests.no-skipped',
      'logging.no-pii',
      'logging.no-console',
      'code.no-any',
      'code.strict-mode',
      'code.no-unused-vars',
      'config.node-version',
      'config.editor-config',
    ],
    strict: [
      'secrets.no-plaintext',
      'secrets.no-env-commit',
      'secrets.gitignore-required',
      'deps.lockfile.required',
      'deps.no-unpinned',
      'deps.no-git-deps',
      'deps.no-vulnerable',
      'deps.no-typosquatting',
      'deps.license-check',
      'security.headers.required',
      'security.cors.safe-default',
      'security.no-eval',
      'security.no-unsafe-regex',
      'security.no-prototype-pollution',
      'auth.no-weak-jwt',
      'auth.no-hardcoded-credentials',
      'auth.session-secure',
      'api.validation.required',
      'api.rate-limiting',
      'api.no-sensitive-logging',
      'sql.no-string-concat',
      'sql.no-raw-queries',
      'tests.unit.required',
      'tests.coverage.min-80',
      'tests.no-skipped',
      'logging.no-pii',
      'logging.no-console',
      'code.no-any',
      'code.strict-mode',
      'code.no-unused-vars',
      'config.node-version',
      'config.editor-config',
    ],
  },
  tools: ['eslint', 'semgrep', 'gitleaks', 'osv-scanner', 'vitest'],
  eslintExtends: [
    'eslint:recommended',
    'plugin:@typescript-eslint/recommended',
    'plugin:security/recommended-legacy',
    'next/core-web-vitals',
  ],
  semgrepRules: [
    'p/javascript',
    'p/typescript',
    'p/nodejs',
    'p/react',
    'p/nextjs',
    'p/jwt',
    'p/sql-injection',
    'p/secrets',
  ],
};
